// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3KFYZ","container":"styles_container__wbaIR","title":"styles_title__DJauk","wrapper":"styles_wrapper__2sTV7","answer":"styles_answer__29qQ2"};